exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a,body,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,html,iframe,input,label,li,object,ol,option,p,select,span,table,td,th,tr,ul{margin:0;padding:0}ol,ul{list-style:none}.clearfix:after,.clearfix:before{content:\"\";display:table}.clearfix:after{clear:both}.clearfix{zoom:1}input::-ms-clear,input::-ms-reveal{display:none}a{text-decoration:none}body,html{width:100%;height:100%;overflow-y:hidden;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./src/common/style.css
// module id = 28
// module chunks = 0